import { FailureType } from "interfaces/failure-type";
import { useLazyFetchV2 } from "hooks/fetch/useLazyFetchV2";
import { makeQueryString } from "core/makeQueryString";

interface LazyFetchResponse {
  count?: number;
  results?: FailureType[];
}

interface LazyFetchFailureType {
  loading: boolean;
  error: boolean;
  fetchCallback: (url: string) => Promise<LazyFetchResponse>;
}

export const useLazyGetFailureTypes = ({
  page = 1,
  pageSize = 10000
}: {
  page?: number;
  pageSize?: number;
}): {
  loading: boolean;
  error: boolean;
  fetchFailureTypes: (
    queryParams?: Record<string, any>
  ) => Promise<LazyFetchResponse>;
} => {
  const {
    loading,
    error,
    fetchCallback
  }: LazyFetchFailureType = useLazyFetchV2("GET");

  return {
    loading,
    error,
    fetchFailureTypes: (queryParams?: Record<string, any>) => {
      const params = { page, size: pageSize, ...queryParams };
      const queryString = makeQueryString(params);

      return fetchCallback(`failure_types${queryString}`);
    }
  };
};
